var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScroll = function SvgScroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.975 21.338a.98.98 0 0 0-.738-.338H26V8a4.013 4.013 0 0 0-4-4H5a4.013 4.013 0 0 0-4 4 3.94 3.94 0 0 0 1.025 2.662.987.987 0 0 0 1.4.088 1 1 0 0 0 .088-1.412A2 2 0 1 1 7 8v16a4.01 4.01 0 0 0 4 4h14a4.013 4.013 0 0 0 4-4 3.94 3.94 0 0 0-1.025-2.663M13 12h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2m-1 5a1 1 0 0 1 1-1h8a1 1 0 0 1 0 2h-8a1 1 0 0 1-1-1m13 9H14.463a4.02 4.02 0 0 0 .412-3h11.863A2.012 2.012 0 0 1 25 26"
  })));
};
export default SvgScroll;